import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useApps } from "../hook";
import { ActionType, AppDispatch, RootState } from "../reducer";
import { SetAppIdAction } from "../reducer/app";

export const useAppIdMap = () => {
  const appId = useSelector((state: RootState) => state.ui.appId);
  const dispatch = useDispatch<AppDispatch>();
  const setAppId = (appId?: string) => {
    const action: SetAppIdAction = {
      appId,
      type: ActionType.SET_APP_ID,
    };
    dispatch(action as any);
  };
  return { appId, setAppId };
};

export const useAppIdRouteParamListener: () => void = () => {
  const { setAppId, appId: appIdState } = useAppIdMap();
  const { "app-id": appIdParam } = useParams();
  useEffect(() => {
    if (appIdState !== appIdParam) {
      setAppId(appIdParam);
    }
  }, [appIdState, appIdParam]);
};

export const useUserHasApp = () => {
  const [apps, setApps] = useApps();
  const { appId } = useAppIdMap();
  const userHasApp = apps.find((app) => app.id === appId) !== undefined;
  return { userHasApp };
};
